<template>
    <div>
        <div class="mine-header flex flex-column align-center">
            <div @click="toBulletin" class="mine-header-info flex align-center">
                <img src="@/assets/images/user/info.png" alt="" />
                <div class="text">
                    <div class="scroll">{{  str  }}</div>
                </div>
            </div>

            <div v-if="tokenIsUseful == 0" class="mine-header-telephone-number">
                <div class="first flex justify-between">
                    <div class="flex align-center">
                        <span> 您还未登录 </span>
                        <span @click="toLogin" class="to-login">
                            去登录</span>

                    </div>
                </div>
            </div>
            <div v-if="tokenIsUseful == 1" class="mine-header-telephone-number">
                <div class="first flex justify-between">
                    <!-- <div>{{ parsePhoneToStar("17396510175") }}</div> -->
                    <div>{{  userInfos.phoneNo  }}</div>
                    <!-- 
                    <img src="@/assets/images/user/editor.png" alt="" /> -->
                </div>
                <div class="second">绑定车牌：{{  carStr  }}</div>
            </div>

            <div class="mine-header-pocket flex justify-between align-center">
                <!-- <div class="mine-header-pocket-item"> -->
                <!-- <div @click="toWallet" class="mine-header-pocket-item">
                    <p class="flex align-center justify-between">
                        <span class="mine-header-pocket-item-label">待缴费用(元)</span>

                        <span class="icon flex align-center justify-center" @click.stop="toRecharge"> <span>充值</span></span>
                    </p>
                    <p class="mine-header-pocket-item-value">{{ userInfo.walletMoney || "0.00" }}</p>
                </div> -->

                <div @click="toWallet" class="mine-header-pocket-item">
                    <p class="flex align-center justify-between">
                        <span class="mine-header-pocket-item-label">余额(元)</span>

                        <!-- <span class="icon flex align-center justify-center" @click.stop="toRecharge"> <span>充值</span></span> -->
                    </p>
                    <p class="mine-header-pocket-item-value">{{  userInfo.walletMoney || "0.00"  }}</p>
                </div>
                <div @click="toMouthCar" class="mine-header-pocket-item">
                    <p class="flex align-center justify-between">
                        <span class="mine-header-pocket-item-label">停车月卡</span>
                        <!-- <span class="icon flex align-center justify-center" @click.stop="toMouthCar">
                            <span>购买</span>
                        </span> -->
                    </p>
                    <p class="mine-header-pocket-item-value">{{  userInfo.monthCardNum || 0  }}</p>
                </div>
                <div @click="toVoucher" class="mine-header-pocket-item">
                    <p class="mine-header-pocket-item-label">优惠券(张)</p>

                    <p class="mine-header-pocket-item-value">{{  userInfo.unUseCouponNum || 0  }}</p>
                    <!-- <p class="mine-header-pocket-item-value">{{ userInfo.couponNum || 0 }}</p> -->

                </div>
            </div>
        </div>
        <!-- <div class="mine-bottom"></div> -->
    </div>
</template>

<script>
import { parsePhoneToStar } from "@/libs/parseData";
import { getPersonalInfo, listMyPlateNum, listBulletin } from "@/api/api";
import { parseCarCode, obj2Param } from "@/libs/tools";
import { mapGetters } from "vuex";

export default {
    name: "MineHeader",
    props: {
        userInfo: Object,
    },

    data() {
        return {
            userInfos: {},
            str: "",
            carStr: "暂未绑定车辆",
        };
    },
    computed: {
        ...mapGetters({ tokenIsUseful: "tokenIsUseful" }),
    },
    mounted() {
        if (!this.tokenIsUseful) return

        getPersonalInfo().then((res) => {
            this.userInfos = res.data;
        });

        listBulletin({
            pageNum: 0,
            pageSize: 3,
        }).then((res) => {
            let length = res.data.rows.length,
                str = "";

            for (let i = 0; i < length; i++) {
                str += `${i + 1}.${res.data.rows[i].title}  `;
            }
            this.str = str;
        });
        listMyPlateNum().then((res) => {
            // 将绑定车牌转成字符串
            if (res.data.length > 0) {
                let str = "",
                    length = res.data.length;
                for (let i = 0; i < length; i++) {
                    str += parseCarCode(res.data[i].plateNum);
                    if (i < length - 1) {
                        str += "、";
                    }
                }

                this.carStr = str;
            }
        });
    },
    methods: {
        parsePhoneToStar,
        toLogin() {
            wx.miniProgram.redirectTo({
                url: `/pages/login/login?type=loginout`,
            });
        },
        //跳转到公告列表
        toBulletin() {
            this.$router.push({ name: "Bulletin" });
        },
        //跳转到用户中心
        toUserInfo() {
            this.$router.push("/mine/userinfo");
        },
        //跳转到余额
        toWallet() {
            this.$router.push({ name: "Wallet" });
        },
        //跳转到代缴费用
        toWaitPay() {
            this.$router.push({ name: "WaitPay" });
        },
        //跳转到月卡
        toMouthCar() {
            let obj = {
                token: localStorage.getItem("token"),
                userId: localStorage.getItem("userId"),
                xcxOpenId: localStorage.getItem("openId"),
            };

            //购买记录
            let str = `${process.env.VUE_APP_BASE_API}qgvip/monthlyCar/parkCardRecord?${obj2Param(obj)}`;
            //停车月卡
            // let str = `${process.env.VUE_APP_BASE_API}qgvip/monthlyCar/listIndex?${obj2Param(obj)}`;

            wx.miniProgram.navigateTo({
                url: `/pages/tab2/webview/webview?jumpUrl=${encodeURIComponent(str)}`,
            });

            // this.$router.push({ name: "WaitPay" });
        },
        //跳转到充值
        toRecharge() {
            this.$router.push({ name: "Recharge" });
        },
        //跳转到抵用券
        toVoucher() {
            this.$router.push({ name: "Voucher" });
        },
    },
};
</script>

<style lang="less" scoped>
.to-login {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    height: 50px;
    width: 100px;
    border-radius: 10px;
    margin-left: 10px;
    margin-top: 5px;
    font-size: 24px;
    color: #009af3;
    background-color: #e3f5ff;
}
.mine-header {
    width: 750px;
    // min-height: 288px;
    min-height: 188px;

    background-color: #fff;

    // position: relative;
    .mine-header-userInfo {
        padding: 20px;

        .mine-header-userInfo-avatar {
            width: 112px;
            height: 112px;
        }

        .mine-header-username {
            font-size: 40px;
            font-weight: 500;
            color: #fff;
        }

        .mine-header-carNum {
            font-size: 28px;
            font-weight: 400;
            color: #fff;
            // opacity: 0.9;
        }
    }

    .mine-header-info {
        height: 48px;
        width: 702px;

        background-color: #fff3e7;
        color: #ff8b19;
        padding: 16px 14px;

        img {
            height: 24px;
            width: 24px;
            margin-right: 17px;
        }

        .text {
            font-size: 20px;
            width: 650px;

            overflow: hidden;
            position: relative;
            // font-size: 12px;
            // transform: scale(0.83, 0.83);
            // white-space: nowrap;
            // margin: -60px;
        }

        .scroll {
            white-space: nowrap;
            animation: 15s mymove linear infinite normal;
        }

        @keyframes mymove {
            0% {
                transform: translateX(0px);
            }

            100% {
                transform: translateX(-100%);
            }
        }
    }

    .mine-header-telephone-number {
        height: 126px;
        width: 100%;
        background-color: #fff;

        padding: 20px 24px;
        font-size: 40px;
        font-family: "PingFangSC";
        font-weight: bolder;

        .first {
            img {
                margin-top: 10px;
                width: 24px;
                height: 24px;
            }
        }

        .second {
            margin-top: 10px;
            color: #666666;
            font-size: 26px;
            font-family: "PingFangSC-Regular";
        }
    }

    .mine-header-pocket {
        width: 702px;
        height: 160px;
        background: url(../../assets/images/user/bg.png) no-repeat;
        background-size: 100% 100%;
        // position: absolute;
        left: 24px;
        bottom: -45px;
        background-color: #fff;

        .mine-header-pocket-item {
            width: 33%;
            height: 100%;
            display: flex;
            flex-direction: column;
            padding: 20px;
            justify-content: space-around;
            color: #ffffff;

            .mine-header-pocket-item-value {
                font-size: 48px;
                font-weight: bold;
            }

            .mine-header-pocket-item-label {
                opacity: 0.8;
                font-size: 26px;
            }

            .icon {
                width: 56px;
                height: 28px;
                color: #00c6ea;
                border-radius: 5px;
                // font-size: 20px;
                background-color: #fff;

                span {
                    font-size: 20px;
                    // font-size: 12px;
                    // transform: scale(0.83, 0.83);
                }
            }
        }
    }
}

.mine-bottom {
    height: 100px;
    width: 100%;
    background-image: linear-gradient(#ffffff 0%, #f5f8fa 50%);
}
</style>
